import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { useMemo } from "preact/hooks"
import { productImagePlaceholder } from "../helpers"
import ProductBadge from "./elements/ProductBadge"

export default function Product({ product, index }) {
    const { format } = useCurrencyFormatting()
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)

    console.log(product);
    const isOOS = product?.availability === "OutOfStock";
    const growingZoneMessage = useMemo(()=> product?.tags1?.find(tag => tag?.includes('Growing Zone:')), []);
    const selectedVariantId = useMemo(() => product?.skus.find(sku => sku.availability === "InStock" && sku?.listPrice > sku?.price)?.id || product?.skus[0]?.id, []);
    const oneLinerMessage = useMemo(()=> product?.customFields?.find(field => field?.key === 'product_card-one_liner')?.value, []);

    const { lowestPrice, lowestCompareAtPrice } = useMemo(() => {
        let lowestPrice = null;
        let lowestCompareAtPrice = null;
    
        // Iterate over the product variants to find the lowest available price
        product?.skus?.forEach(sku => {
          if (sku?.availability === "InStock") {
            if (lowestPrice === null || sku?.price < lowestPrice) {
              lowestPrice = sku?.price;
              lowestCompareAtPrice = sku?.listPrice;
            }
          }
        });
    
        return { lowestPrice, lowestCompareAtPrice };
      }, [product?.skus]);

    return (
        <SerpElement
            as="li"
            hit={product}
            // ns-col-12 ns-col-xs-6 ns-col-l-4 ns-p-2 ns-my-2 ns-mx-0
            class="ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit grid__item scroll-trigger animate--slide-in"
            data-cascade=""
            style={`--animation-order: ${index};`}
        >
            {/* <style data-shopify="">.fa-star, .fa-star-checked, .fa-star-half-o, .fa-star-o, .stamped-fa-star, .stamped-fa-star-checked, .stamped-fa-star-half-o, .stamped-fa-star-o, .stamped-starrating {
                color:#007b5f;
                }
                .stamped-badge {
                display:flex;
                align-items:flex-end;
                }
                .stamped-badge-caption {
                font-size:14px;
                margin-left:0.3rem;
                font-family: 'Gill Sans';
                margin-bottom:3px;
                }
                @media screen and (min-width:990px) {
                .stamped-badge-caption {
                font-size:16px;
                }
                }
            </style> */}
            <div class="card-wrapper product-card-wrapper">
                <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
                    <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 125.0%;">
                        <div class="card__media">
                        <div class="media media--transparent media--hover-effect">
                            <img srcSet={`${product?.imageUrl}&width=165 165w,${product?.imageUrl}&width=360 360w,${product?.imageUrl}&width=533 533w,${product?.imageUrl}&width=720 720w,${product?.imageUrl}&width=940 940w,${product?.imageUrl}&width=1066 1066w,${product?.imageUrl} 1200w`} src={`${product?.imageUrl}&width=533`} sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt={product?.name} class="motion-reduce" loading="lazy" width="1200" height="1553" />

                            {product?.alternateImageUrls?.length > 0 && (
                                <img srcSet={`${product?.alternateImageUrls[0]}&width=165 165w,${product?.alternateImageUrls[0]}&width=360 360w,${product?.alternateImageUrls[0]}&width=533 533w,${product?.alternateImageUrls[0]}&width=720 720w,${product?.alternateImageUrls[0]}&width=940 940w,${product?.alternateImageUrls[0]}&width=1066 1066w,${product?.alternateImageUrls[0]} 1200w`} src={`${product?.alternateImageUrls[0]}&width=533`} sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="" class="motion-reduce" loading="lazy" width="1200" height="1553" />
                            )}
                        </div>
                        </div>
                        <div class="card__content">
                        <div class="card__information">
                            <h3 class="card__heading">
                                <a href={`${product?.url}?variant=${selectedVariantId}`} id={`StandardCardNoMediaLink-template--15680832340073__product-grid-${product?.productId}`} class="full-unstyled-link" aria-labelledby={`StandardCardNoMediaLink-template--15680832340073__product-grid-${product?.productId} NoMediaStandardBadge-template--15680832340073__product-grid-${product?.productId}`}>
                                {product?.name}
                                </a>
                            </h3>
                        </div>
                        </div>
                    </div>
                    <div class="card__content">
                        <div class="card__information">
                        <div class="card__outdoor-gz">
                           {growingZoneMessage && <span class="card--growing-zone">{growingZoneMessage}</span>}
                        </div>
                        <h3 class="card__heading" id={`title-template--15680832340073__product-grid-${product?.productId}`}>
                            <a href={`${product?.url}?variant=${selectedVariantId}`} id={`CardLink-template--15680832340073__product-grid-${product?.productId}`} class="full-unstyled-link" aria-labelledby={`CardLink-template--15680832340073__product-grid-${product?.productId} Badge-template--15680832340073__product-grid-${product?.productId}`}>
                            {product?.name}
                            </a>
                        </h3>
                        <div class="card-information">
                            <div class="card--one-liner">
                                {oneLinerMessage && oneLinerMessage}
                            </div>
                            <div class="stamped-container" data-product-id={product?.productId}>
                                <div class="stamped-product-reviews-badge" data-id={product?.productId}></div>
                            </div>
                            <span class="caption-large light"></span>
                            {isOOS ? (<span class="price-item price-item--sold-out price-item--product-card">Sold out</span>) : (<div class="price">
                                <div class="price__container">
                                   {lowestCompareAtPrice > lowestPrice ? (
                                    <>
                                        <span class="price-item price-item--sale price-item--product-card">
                                            From {format(lowestPrice).replace(/\.00$/, '')}
                                        </span>
                                        <span class="price-item price-item--regular price-item--product-card">
                                            <s>{format(lowestCompareAtPrice).replace(/\.00$/, '')}</s>
                                        </span>
                                    </>
                                    ):(
                                        <span class="price-item price-item--regular price-item--product-card">
                                            From {format(lowestPrice).replace(/\.00$/, '')}
                                        </span>
                                    )}
                                </div>
                            </div>)}
                        </div>
                        </div>
                    </div>
                    <div class="card__badge top left">
                        <ProductBadge product={product} />
                    </div>
                </div>
            </div>
        </SerpElement>
    )
}


{/* <img
                class="ns-w-100 ns-h-auto"
                src={product.imageUrl ?? productImagePlaceholder}
                alt={product.name}
                width="600"
                height="400"
            />
            <div class="ns-relative ns-mt-2" data-nosto-element="product">
                {tags.length > 0 && (
                    <div class="ns-tags ns-absolute ns-mb-1">
                        {tags.map(v => (
                            <span class={v.class}>{v.label}</span>
                        ))}
                    </div>
                )}
                {product.brand && <div class="ns-color-black ns-mb-1 ns-font-4">{product.brand}</div>}
                <div class="ns-clipped ns-text-four-lines ns-text-md-three-lines ns-mb-2 ns-font-4">{product.name}</div>
                <div>
                    <span>{format(product.price)}</span>
                    {product.listPrice && product.listPrice > product.price && (
                        <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
                            {format(product.listPrice)}
                        </span>
                    )}
                </div>
            </div> */}